import { useState } from "react";
import { useSelector } from "react-redux";
import {
  getUserNotification,
  markNotificationRead,
} from "../../services/common/notificationsApiFn";
import { handleOpenSnackBar } from "../../utils";

const useNotifications = () => {
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const userData = useSelector((state) => state.userData.user);
  const [allNotifications, setAllNotifications] = useState([]);

  const fetchAllNotifications = async () => {
    try {
      setNotificationsLoading(true);
      const response = await getUserNotification(
        userData?.adminId || userData?._id,
        userData?.role
      );
      if (response.data.status === "success") {
        setAllNotifications(response.data.data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setNotificationsLoading(false);
    }
  };

  const markUserNotificationRead = async () => {
    try {
      setNotificationsLoading(true);
      const response = await markNotificationRead(
        userData?.adminId || userData?._id
      );
      if (response.data.status === "success") {
        fetchAllNotifications();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setNotificationsLoading(false);
    }
  };

  return {
    notificationsLoading,
    allNotifications,
    fetchAllNotifications,
    markUserNotificationRead,
  };
};

export default useNotifications;
